// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"f48f55b4","573":"9fa86557"}[chunkId] + ".chunk.css";
};